import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar, FunctionField } from 'react-admin';
import { Box, Breadcrumbs, Link, Typography, Chip } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const ZoneListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const ConfigurationBreadcrumbs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/configuration')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Configuration
        </Link>
        <Typography color="text.primary">Zones</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const ZoneList = () => {
  const navigate = useNavigate();

  return (
    <List
      title="Zones"
      actions={<ZoneListActions />}
      filters={[]}
      empty={<CustomEmptyState resource="zones" onAction={() => navigate('/crm/zones/create')} />}
    >
      <ConfigurationBreadcrumbs />
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="description" />
        <FunctionField
          label="Color"
          render={(record: { color?: string }) => (
            <Chip
              label={record.color || '#9C27B0'}
              size="small"
              sx={{
                bgcolor: record.color || '#9C27B0',
                color: 'white',
                fontWeight: 'bold',
              }}
            />
          )}
        />
      </Datagrid>
    </List>
  );
};
